import { IsInt, IsNotEmpty, IsOptional, IsString, MaxLength, Matches } from 'class-validator';

export class ProfileUpdateRequest {
    @IsOptional()
    @IsInt()
    public id?: number;

    @IsString()
    @IsNotEmpty()
    @MaxLength(50)
    @Matches(/^[^%;]*$/, { message: 'Name must not contain % or ; characters' })
    public name: string;

    @IsString()
    @IsNotEmpty()
    public profile: string;

    @IsOptional()
    @IsInt()
    public sort: number;

    @IsOptional()
    @IsInt()
    public categoryId?: number;

    constructor(data?: Partial<ProfileUpdateRequest>) {
        this.id = data?.id;
        this.name = data?.name;
        this.profile = data?.profile;
        this.sort = data?.sort;
        this.categoryId = data?.categoryId;
    }
}
